export default __webpack_public_path__ + "static/media/youtube.0d864fd7.svg";